<template>
  <section class="p-2">
  
  <v-card   class="">
    <v-card-title class="d-flex justify-space-between p-0 m-0">
        <div class="ps-2 headingFontsize">Roles List</div>
        <div>
          <bread-crumb :bread-crumbs="['Roles List']" />
        </div>
      </v-card-title>
      <v-divider class="p-0 m-0 primary--text"></v-divider>
    <!-- <v-card-title>Roles List</v-card-title> -->
    <v-card-subtitle>
      <v-row>
        <v-col cols="12" lg="4" xs="12">
          <v-btn depressed  @click="downloadExcelsheet" class="mt-2" color="primary" small
          ><v-icon small>mdi-file-excel-outline</v-icon>Export
        </v-btn>
        </v-col>
        <v-col cols="12" lg="4" xs="12"></v-col>
        <v-col cols="12" lg="4" xs="12">
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Type here to filter the table data."
        single-line
        hide-details
        dense clearable
      ></v-text-field></v-col></v-row>
    </v-card-subtitle>
    <v-data-table fixed-header  height="55vh"
      class="mb-16  py-4"
      :headers="headers"
      :items="RolesListResponse"
      :search="search"
      dense
    >
      <template v-slot:item.employee_list="{ item }">
        <p>{{ item.employee_list.length }}</p>
      </template>
      <template v-slot:item.calories="{ item }">
        <v-chip :color="getColor(item.calories)" dark>
          {{ item.calories }}
        </v-chip>
      </template>
      <template v-slot:item.actions="{ item }">
        <router-link
          :to="
            `/EditRole/` +
            item.role_id +
            `/` +
            item.role_code +
            `/` +
            item.role_name
          "
          ><v-icon
            small
            style="color: #ff6b00"
            class="mr-2"
            @click="editRole(item)"
          >
            mdi-content-save-edit-outline
          </v-icon></router-link
        >

        <!-- <v-icon small style="color: #ff6b00" @click="deleteRole(item)">
          mdi-trash-can-outline
        </v-icon> -->
      </template>
    </v-data-table>
  </v-card>
</section>
</template>

<script>
import BreadCrumb from "@/components/navigations/BreadCrumb.vue"
import axios from "axios";
export default {
  name: "Roles List",
  data() {
    return {
      search: "",
      headers: [
        {
          text: "Role Name",
          value: "role_name"
        },
        { text: "Description", value: "description" },
        { text: "User Count", value: "employee_list" },
        { text: "Expiry Date", value: "expiry_date" },
        { text: "Actions", value: "actions", sortable: false }
      ],
      RolesListResponse: []
    };
  },

  components: {
    BreadCrumb,
   
  },


  mounted() {
    this.getRoles();
  },
  methods: {
    async downloadExcelsheet() {
      if (this.RolesListResponse) {
        this.exportToExcel(this.headers, this.RolesListResponse, "roles List");
      }
    },
    getRoles() {
      //   console.log("url", url);
      console.log("this.$store.state.app.token", this.$store.state.app.token);

      axios
        .get(`${process.env.VUE_APP_BASEURL}:8005/api/v1/roles/all_roles`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${sessionStorage.getItem("__ac_mn_tk")}`,
            accept: "application/json"
          }
        })
        .then((response) => {
          this.RolesListResponse = response.data.data;
        });
    },
    editRole(role) {
      console.log("role", role);
    },
    deleteRole(role) {
      console.log("role", role);
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/global.scss";
.text-color {
  color: #ff6b00;
}
</style>
